import { getEnv } from "../helpers/env";

export const cloudinaryService = {
  createUploadWithProgressRequest: (): XMLHttpRequest => {
    const cloudinaryRequest = new XMLHttpRequest();
    const cloudName = getEnv("NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME");
    const resourceType = "video";
    const url = `https://api.cloudinary.com/v1_1/${cloudName}/${resourceType}/upload`;

    cloudinaryRequest.open("POST", url, true);

    return cloudinaryRequest;
  },
};
